import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { Subscription } from 'rxjs';

import { ReportService } from '@services/report.service';
import { Report } from '@classes/report/report';
import { ReportCustom } from '@classes/report/report-custom';
import { ReportMode } from '@enums/report-mode.enum';
import { ChartType } from '@enums/chart-type.enum';

@Component({
    selector: 'app-report-print',
    templateUrl: './report-print.component.html',
    styleUrls: ['./report-print.component.scss']
})
export class ReportPrintComponent implements OnInit, OnDestroy {
    @Input() report: Report;
    @Input() customReports: ReportCustom[];
    @Input() selMode: ReportMode;

    private printModeSub: Subscription;

    isPrintMode: boolean;
    reportMode = ReportMode;
    chartType = ChartType;

    constructor(
        private reportSrv: ReportService
    ) { }

    ngOnInit() {
        this.initSubscriptions();
    }

    private initSubscriptions(): void {
        this.printModeSub = this.reportSrv.printModeChanged
        .subscribe(printMode => {
            this.isPrintMode = printMode;
        });
    }

    ngOnDestroy(): void {
        if(this.printModeSub) {
            this.printModeSub.unsubscribe();
        }
    }
}
